export const PoolMode = {
  RANDOM: 'random',
  ORDERED_CAPPING: 'ordered_capping',
};
